import React from 'react'
import { TextareaForm } from 'app/assets/styles'
import { SmallText } from 'app/common/typography'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'
import { colors } from 'app-v2/design-systems/theme'
import { fonts } from 'app-v2/design-systems/typography/fonts'
import styled from 'styled-components'

type Props = {
    name: string,
    labelKey: string,
    placeholderKey: string,
    className?: string,
    maxlength?: string,
    handleChange: (SyntheticEvent<any>) => void,
    handleBlur: () => void,
    value: string,
    intl: IntlShape
}

const Textarea = injectIntl((props: Props) => {
    const {
        name,
        labelKey,
        placeholderKey,
        className,
        maxlength = '1000',
        handleChange,
        handleBlur,
        value,
        intl
    } = props
    return (
        <TextareaForm>
            <StyledSmallText color={colors.lightGrey}>
                {intl.formatMessage({ id: labelKey })}
            </StyledSmallText>
            <textarea
                name={name}
                maxLength={maxlength}
                placeholder={intl.formatMessage({ id: placeholderKey })}
                className={className}
                onChange={handleChange}
                onBlur={handleBlur}
                value={value}
                rows={1}
            />
        </TextareaForm>
    )
})

const StyledSmallText = styled(SmallText)`
    color: ${colors.bbqBrown};
    font-family: ${fonts.flameSansRegular};
`

export { Textarea }
